<div class="modal-confirm" data-uit="modal-confirm">
    <ca-modal-container
        [modalTitle]="title"
        [isTitleCentered]="isTitleCentered"
        [isBodyCentered]="isBodyCentered"
        (dismiss)="cancel()"
        [showClose]="showClose"
        class="modal-confirm"
        [ngClass]="customCssClass"
    >
        <p style="white-space: pre-line">{{ message }}</p>
        <p class="text-warning" style="white-space: pre-line" *ngIf="warningMessage">{{ warningMessage }}</p>
        <input
            *ngIf="showInput"
            (keyup.enter)="!isOkButtonDisabled() && ok()"
            type="text"
            class="form-control mb-3"
            data-uit="modal-input"
            [(ngModel)]="inputText"
            [placeholder]="inputPlaceholder"
        />
        <ng-content></ng-content>
    </ca-modal-container>
    <div class="d-flex justify-content-end" [ngClass]="buttonsContainerCustomCssClass">
        <!-- OK Button: Autofocus is conditionally applied: If Input is present, focus the input. If not, focus the button -->
        <button
            type="button"
            *ngIf="showCancel"
            class="btn btn-secondary"
            ngClass="{{ !showCustom ? 'w-50' : 'w-30' }}"
            (click)="cancel()"
            data-uit="modal-confirm-cancel-button"
        >
            {{ cancelText }}
        </button>
        <button
            type="button"
            [caAutoFocus]="!showInput"
            [disabled]="isOkButtonDisabled()"
            class="btn"
            ngClass="{{ !showCancel && !showCustom ? 'w-100' : showCancel || showCustom ? 'w-50' : 'w-30' }} , {{ customCssClassConfirmBtn }}"
            (click)="ok()"
            data-uit="modal-confirm-ok-button"
        >
            {{ confirmText }}
        </button>
        <button
            type="button"
            *ngIf="showCustom"
            class="btn btn-secondary"
            ngClass="{{ !showCancel ? 'w-50' : 'w-30' }}"
            (click)="customAction()"
            data-uit="modal-confirm-custom-button"
        >
            {{ customText }}
        </button>
    </div>
</div>
